import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import styles from './CustomerBioShort.module.scss';
import avatar from "../../constants/images/avatar.svg";
import PackageDetailsOrder from "../PackageDetailsOrder/PackageDetailsOrder";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {axiosService} from "../../services/axios.service";
import {endPoints, resolveMediaUrl} from "../../configs/urls";

const CustomerBioShort = ({order, type, offerId, orderId, application, cleanerApplicationId}) => {
    const [cleanerApplications, setCleanerApplications] = useState([]);
    const [isAlreadyApplied, setIsAlreadyApplied] = useState(false);

    const {cleaner} = useSelector(state => state.cleanerDetails);

    const {
        pk: id,
        created_by_user,
        get_total_price,
        request_datetime,
        service_types,
        services,
        cleaning_type,
        room_count,
        wc_count,
        reg_window_count,
        pano_window_count,
        service_package,
        request_price
    } = order;

    const navigate = useNavigate();


    useEffect(() => {
        const getCleanerApplicationsByCleaningRequest = async () => {
            try {
                const res = await axiosService.get(`${endPoints.application.base}${id}/applications-by-request/`);

                setCleanerApplications(res.data.results);
            } catch (error) {
                console.error(error)
            }
        }

        getCleanerApplicationsByCleaningRequest();
    }, []);

    useEffect(() => {
        // checking whether cleaner has already been applied to this cleaning request
        if (type === 'apply') {
            if (cleanerApplications?.length > 0) {
                const isAlreadyApplied = cleanerApplications?.some((application, index) =>
                    application?.created_by_user.cleaner_id === cleaner.id);

                setIsAlreadyApplied(isAlreadyApplied);
            }
        }

        if (type === 'alreadyApplied') {
            setIsAlreadyApplied(true);
        }
    }, [cleanerApplications])


    const handleFormatDateTime = (datetimeString) => {
        const inputDate = new Date(datetimeString);

        const day = inputDate.getDate().toString().padStart(2, '0');
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // months start from 0
        const hour = inputDate.getHours().toString().padStart(2, '0');
        const minute = inputDate.getMinutes().toString().padStart(2, '0');

        const formattedDate = `${day}.${month} ${hour}:${minute}`;

        return formattedDate;
    }

    const handleNavigateToRoute = () => {
        if (type === "alreadyApplied") {
            navigate(`${MAIN_ROUTES.CLEANER_APPLICATION}/${cleanerApplicationId}`);
        }

        if (isAlreadyApplied) {
            return;
        }

        switch (type) {
            case 'apply': {
                navigate(`${MAIN_ROUTES.APPLY_FOR_ORDER}/${id}`);
                break;
            }
            case 'offer': {
                navigate(`${MAIN_ROUTES.ACCEPT_ORDER}/${offerId}`, {state: {type: 'offer'}});
                break;
            }
            case 'order': {
                navigate(`${MAIN_ROUTES.ACTIVE_ORDER}/${orderId}`, {state: {type: 'order'}});
                break
            }
        }
    }

    return (
        <div
            className={`${styles.customerBioShort} ${(isAlreadyApplied && type !== 'alreadyApplied') ? styles.isApplied : ''}`}
            onClick={handleNavigateToRoute}
        >
            <div className={styles.customerBioShort_fullName}>
                <img src={resolveMediaUrl(created_by_user?.photos[0]) || avatar} alt="user`s profile photo"/>

                <div className={styles.customerBioShort_fullName_titleContainer}>
                    <div>
                        <h3 className={styles.fullName}>{order.created_by_user.first_name}</h3>
                        <p className={styles.badge}>{order.address}</p>
                    </div>

                    {(type === 'apply' && isAlreadyApplied) &&
                        <p style={{textAlign: 'right'}} className={`${styles.applied} ${styles.laptop}`}>Ви вже подались
                            на цю заявку</p>}
                    {(type === 'apply' && !isAlreadyApplied) &&
                        <button className={`${styles.customerBioShort_info_button} ${styles.laptop}`}>
                            {type === 'apply' ? 'Подати заявку' : 'Прийняти'}
                        </button>}
                    {type === 'offer' && <button
                        className={`${styles.customerBioShort_info_button} ${styles.laptop}`}>Переглянути</button>}
                </div>
            </div>

            <div className={styles.customerBioShort_info}>
                <div className={styles.customerBioShort_info_detailed}>
                    <div className={styles.customerBioShort_info_detailed_price}>
                        <p>₴ {application ? application?.application_price : (+request_price || get_total_price)}</p>
                        <p>Оплата</p>
                    </div>

                    <div className={styles.customerBioShort_info_detailed_date}>
                        <p>{handleFormatDateTime(request_datetime)}</p>
                        <p>Дата та час</p>
                    </div>

                    {type !== 'order' &&
                        <div className={styles.customerBioShort_info_detailed_applications}>
                            <p>Кількість поданих заявок</p>
                            <p>{cleanerApplications?.length < 5 ? 'Менше 5' : (cleanerApplications?.length < 10 ? 'Менше 10' : 'Більше 10')}</p>
                        </div>}
                </div>

                <PackageDetailsOrder
                    showTitle={false}
                    style={{}}
                    selectedPackage={service_package?.name}
                    services={services}
                    countOrdinaryWindows={reg_window_count}
                    countPanoramicWindows={pano_window_count}
                    typeCleaning={cleaning_type}
                    countRooms={room_count}
                    countBathrooms={wc_count}
                />

                {(type === 'apply' && isAlreadyApplied) &&
                    <p className={`${styles.applied} ${styles.mobile}`}>Ви вже подались на цю заявку</p>}
                {(type === 'apply' && !isAlreadyApplied) &&
                    <button className={`${styles.customerBioShort_info_button} ${styles.mobile}`}>
                        {type === 'apply' ? 'Подати заявку' : 'Прийняти'}
                    </button>}
                {type === 'offer' &&
                    <button className={`${styles.customerBioShort_info_button} ${styles.mobile}`}>Переглянути</button>}
            </div>
        </div>
    );
};

export default CustomerBioShort;
